import { getComplaintStats } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

// complaintStatus[] is a per-status breakdown, e.g. [{ status: "OPEN", count: 4 }, ...].
// Reading directly off it (rather than the top-level pendingCount/closedCount
// fields, whose exact scope isn't confirmed) keeps these tiles matched to the
// two actions this admin UI actually performs: Resolve -> CLOSED, Reject -> REJECTED.
const countFor = (breakdown, status) =>
  breakdown?.find((entry) => entry.status === status)?.count ?? 0;

export const useComplaintStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["complaintStats"],
    queryFn: getComplaintStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalCount: data?.totalCount ?? 0,
      openCount: countFor(data?.complaintStatus, "OPEN"),
      resolvedCount: countFor(data?.complaintStatus, "CLOSED"),
      rejectedCount: countFor(data?.complaintStatus, "REJECTED"),
    },
    isLoading,
    isError,
  };
};
